/**
 * Resolve a imagem de um perfil de produtor.
 *
 * A API devolve o objeto da foto ora como `photo`, ora como `photoImage`
 * (ex.: o payload de /evento/{slug} usa `photo`), por isso as duas chaves
 * são aceitas. Também cai de `thumb` para `path` — e vice-versa — quando
 * apenas uma das versões vem preenchida.
 *
 * @param {object} profile  producer_profile vindo da API
 * @param {'thumb'|'path'} size  versão preferida da imagem
 * @returns {string|null}
 */
export function getProducerProfileImage(profile, size = 'thumb') {
    const photo = profile?.photo || profile?.photoImage;

    if (!photo) {
        return null;
    }

    return size === 'path'
        ? (photo.path || photo.thumb || null)
        : (photo.thumb || photo.path || null);
}

export default getProducerProfileImage;
